<template>
  <div>
    <!-- Page header -->
    <div class="flex items-center gap-3 px-4 pt-4">
      <span
        class="flex items-center justify-center w-10 h-10 rounded-xl bg-taxiye-100 text-taxiye-500"
      >
        <span class="material-icons-round">person_add</span>
      </span>
      <div>
        <h2 class="text-lg font-semibold text-gray-800">New User</h2>
        <p class="text-sm text-gray-500">Add a new user to this corporate.</p>
      </div>
    </div>

    <form @submit.prevent="add">
      <div
        class="p-6 m-4 bg-white border border-gray-200 shadow-sm max-w-2xl rounded-2xl"
      >
        <div class="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <label class="block">
            <span class="text-sm font-medium text-gray-600">First Name</span>
            <input
              v-model="firstName"
              class="block w-full mt-1 border-gray-300 shadow-sm form-input rounded-xl text-sm focus:border-taxiye-300"
              placeholder="Abbay"
            />
          </label>
          <label class="block">
            <span class="text-sm font-medium text-gray-600">Last Name</span>
            <input
              v-model="lastName"
              class="block w-full mt-1 border-gray-300 shadow-sm form-input rounded-xl text-sm focus:border-taxiye-300"
              placeholder="Kassa"
            />
          </label>

          <label class="block">
            <span class="text-sm font-medium text-gray-600">Email</span>
            <input
              v-model="email"
              class="block w-full mt-1 border-gray-300 shadow-sm form-input rounded-xl text-sm focus:border-taxiye-300"
              type="email"
              placeholder="contact@sheraton.com"
            />
          </label>
          <label class="block">
            <span class="text-sm font-medium text-gray-600">Password</span>
            <input
              v-model="password"
              class="block w-full mt-1 border-gray-300 shadow-sm form-input rounded-xl text-sm focus:border-taxiye-300"
              type="Password"
              placeholder="password"
            />
          </label>
          <label class="block">
            <span class="text-sm font-medium text-gray-600"
              >Confirm Password</span
            >
            <input
              v-model="confirmPassword"
              class="block w-full mt-1 border-gray-300 shadow-sm form-input rounded-xl text-sm focus:border-taxiye-300"
              type="password"
              placeholder="password"
            />
          </label>
        </div>

        <div class="mt-6">
          <span class="text-sm font-medium text-gray-600">Roles</span>
          <div v-if="loadingRoles" class="mt-2 text-sm text-gray-500">
            <span class="mr-1 text-base align-middle material-icons-round spin"
              >sync</span
            >
            Loading...
          </div>
          <div class="flex flex-wrap gap-2 mt-2" v-else>
            <label
              v-for="role in roles"
              :key="role._id"
              :for="role.roleName"
              class="inline-flex items-center px-3 py-2 text-sm text-gray-700 border border-gray-200 cursor-pointer rounded-xl hover:bg-gray-50"
            >
              <input
                type="checkbox"
                :name="role.roleName"
                v-model="roleSelection[role._id]"
                :id="role.roleName"
                class="mr-2 rounded text-taxiye-500 focus:ring-taxiye-300"
              />
              <span>{{ role.roleName }}</span>
            </label>
          </div>
        </div>

        <div
          class="flex items-center justify-between pt-5 mt-6 border-t border-gray-100"
        >
          <button
            type="button"
            @click="changePage('index')"
            class="inline-flex items-center h-10 px-4 text-sm font-medium text-gray-600 transition-colors rounded-xl hover:bg-gray-100"
          >
            <span class="mr-1 text-base material-icons-round">arrow_back</span>
            Back
          </button>
          <button
            :disabled="busy"
            class="inline-flex items-center justify-center h-10 px-6 text-sm font-semibold text-white transition-colors rounded-xl shadow-sm"
            :class="
              busy
                ? 'bg-taxiye-200 cursor-not-allowed'
                : 'bg-taxiye-500 hover:bg-taxiye-600'
            "
          >
            Add
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: ["corporate", "changePage"],
  data() {
    return {
      busy: false,
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
      roles: [],
      roleSelection: {},
      loadingRoles: true,
    };
  },
  created() {
    this.fetchRoles();
  },
  methods: {
    add() {
      const corporateRoles = Object.entries(this.roleSelection)
        .filter(([, v]) => v)
        .map(([k]) => k);

      if (this.password != "" && this.password == this.confirmPassword) {
        var data = {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          password: this.password,
          corporate: this.corporate._id,
          corporateRoles,
        };
        console.log(data);
        this.busy = true;
        this.$misc
          .post("/accounts", data)
          .then(response => {
            console.log(response);
            window.flash({
              body: "User created successfully!",
              type: "success",
            });
            this.changePage("index");
          })
          .catch(err => console.log(err))
          .finally(() => (this.busy = false));
      }
    },
    fetchRoles() {
      this.loadingRoles = true;
      this.$http
        .get(`/corporates/${this.corporate._id}/roles`)
        .then(({ data: { data } }) => {
          this.roles = data;
          for (const role of data) {
            this.roleSelection[role._id] = false;
          }
          this.loadingRoles = false;
        });
    },
  },
};
</script>
